export default __webpack_public_path__ + "static/media/minor_custodial_account_dark.6d015717.png";